module.exports = __webpack_public_path__ + "static/media/datePickerCalendar.325ae1a8.svg";